import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-custom-select',
  templateUrl: './custom-select.component.html',
  styleUrls: ['./custom-select.component.css'],
})
export class CustomSelectComponent implements OnInit {
  @Input() options: any;
  @Output() selectionChange = new EventEmitter<string>();
  @Output() openDrop = new EventEmitter<string>();

  searchTerm: string = '';
  filteredOptions: any[] = [];

  searchCompany: string;

  selectedOption: any = 'Select company...';
  showMyContainer: boolean = false;
  companiesSearch: any;
  showClearFIlter: boolean = false;

  constructor(private translate: TranslateService) {}

  ngOnInit() {
    this.translate.get('companies.selectCompany').subscribe((res: string) => {
      this.selectedOption = res;
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.options) {
      this.filteredOptions = this.options;
    }
  }

  filterOptions() {
    this.filteredOptions = this.options.filter((option) =>
      option.name.toLowerCase().includes(this.searchTerm.toLowerCase())
    );
  }

  openDropdown() {
    this.showMyContainer = !this.showMyContainer;
    this.filteredOptions = this.options;
  }

  selectOption(option: any) {
    this.showMyContainer = false;
    this.searchTerm = '';
    console.log(option);
    if (option) {
      console.log(option);
      this.selectedOption = option.name;
      this.showClearFIlter = true;
    } else {
      this.translate.get('companies.selectCompany').subscribe((res: string) => {
        this.selectedOption = res;
      });
      this.showClearFIlter = false;
    }
    this.selectionChange.emit(option);
    this.filteredOptions = [];
  }
}
